import { CircularProgress } from "@mui/material";
import { useMemo, useState } from "react";
import { useBets } from "../../common/contexts/betContext";
import { useFixtures } from "../../common/contexts/fixturesContext";
import {
    BetFilters,
    applyBetFilters,
    deriveTeamOptions,
    emptyBetFilters,
} from "./betFilters";
import BetsFilterBar from "./BetsFilterBar";
import "./MobileBets.scss";
import MobileBetsBody from "./MobileBetsBody";

export const MobileBets = () => {
  const { bets, isLoading } = useBets();
  const { matches } = useFixtures();
  const [filters, setFilters] = useState<BetFilters>(emptyBetFilters);

  const teamOptions = useMemo(
    () => deriveTeamOptions(bets, matches),
    [bets, matches]
  );
  const filteredBets = useMemo(
    () => applyBetFilters(bets, matches, filters),
    [bets, matches, filters]
  );

  return (
    <div className="mobileBets__root">
      <BetsFilterBar
        filters={filters}
        setFilters={setFilters}
        teamOptions={teamOptions}
      />

      {isLoading ? (
        <div
          style={{
            width: "100%",
            minHeight: "40vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <MobileBetsBody bets={filteredBets} hasAnyBets={bets.length > 0} />
      )}
    </div>
  );
};
